import { AsyncPipe, DecimalPipe, KeyValuePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { TableService } from '../../../core/services/table.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from './../../../core/directives/sortable.directive';
import { FormsModule } from '@angular/forms';
import {
  NgbPaginationModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ITableColumn } from '@core/interfaces/itable-column';
import { IAction } from '@core/interfaces/i-action';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faUserTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    imports: [
    DecimalPipe,
    FormsModule,
    AsyncPipe,
    NgbTypeaheadModule,
    NgbdSortableHeader,
    NgbPaginationModule,
    KeyValuePipe,
    CommonModule,
    FontAwesomeModule
],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [TableService, DecimalPipe]
})
export class TableComponent {
  @Input() data: any = [];
  @Output() iconClick: EventEmitter<IAction> = new EventEmitter<IAction>();

  faEdit = faEdit;
  faUserTimes = faUserTimes;

  columns: ITableColumn[] = [
    {
      scope: 'col',
      sortableName: 'firstName',
      label: 'First Name',
    },
    {
      scope: 'col',
      sortableName: 'lastName',
      label: 'Last Name',
    },
    {
      scope: 'col',
      sortableName: 'email',
      label: 'Email',
    },
    // {
    //   scope: 'col',
    //   sortableName: 'id',
    //   label: 'Id',
    // },
    {
      scope: 'col',
      label: 'Edit',
      icon: faEdit,
    },
    {
      scope: 'col',
      label: 'Delete',
      icon: faUserTimes,
    },
  ];

  records$: Observable<any[]>;
  total$: Observable<number>;

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  constructor(public service: TableService) {
    this.records$ = service.records$;
    this.total$ = service.total$;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  handleAction(record: any, col: any): void {
	  this.iconClick.emit({record, col});
  }
}
